import { render, staticRenderFns } from "./PrivateDiscussionFacebook.vue?vue&type=template&id=93451fb6"
import script from "./PrivateDiscussionFacebook.vue?vue&type=script&lang=js"
export * from "./PrivateDiscussionFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93451fb6')) {
      api.createRecord('93451fb6', component.options)
    } else {
      api.reload('93451fb6', component.options)
    }
    module.hot.accept("./PrivateDiscussionFacebook.vue?vue&type=template&id=93451fb6", function () {
      api.rerender('93451fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/PrivateDiscussionFacebook.vue"
export default component.exports